import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { updateMyProfileModal } from '../../features/crProfileSlice';
import { AppDispatch } from '../../store/store';

type IMyProfileModalProps = {
  openMyProfile: boolean;
  openMyProfileModal: (param: string | null) => void;
  closeMyProfileModal: () => void;
  myProfileLink: string | null;
};

export const useMyProfileModal = (isMyProfileModalEnable: boolean): IMyProfileModalProps => {
  const dispatch = useDispatch<AppDispatch>();
  const [openMyProfile, setOpenMyProfile] = useState(false);
  const [myProfileLink, setMyProfileLink] = useState<string | null>('');
  const openMyProfileModal = (param: string | null) => {
    setOpenMyProfile(true);
    setMyProfileLink(param);
    dispatch(updateMyProfileModal(true));
  };
  const closeMyProfileModal = () => {
    setOpenMyProfile(false);
  };

  useEffect(() => {
    if (!isMyProfileModalEnable) return;

    const observer = new MutationObserver(() => {
      const anchors = Array.from(document.getElementsByClassName('open-profile-modal'));

      anchors.forEach((anchor) => {
        const handleClick = (e: Event) => {
          e.preventDefault();
          const href = (e.currentTarget as HTMLAnchorElement)?.getAttribute('href');
          openMyProfileModal(href);
        };

        anchor.removeEventListener('click', handleClick);
        anchor.addEventListener('click', handleClick);
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });

    return () => observer.disconnect();
  }, [isMyProfileModalEnable]);
  return { openMyProfile, openMyProfileModal, closeMyProfileModal, myProfileLink };
};

export default useMyProfileModal;
